module.exports = __webpack_public_path__ + "static/img/jl-hop.6c40c26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/jl-hop.png
// module id = 0bco
// module chunks = 1